import { render, staticRenderFns } from "./claim_apply.vue?vue&type=template&id=6bcdf9bf&scoped=true"
import script from "./claim_apply.vue?vue&type=script&lang=js"
export * from "./claim_apply.vue?vue&type=script&lang=js"
import style0 from "./claim_apply.vue?vue&type=style&index=0&id=6bcdf9bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdf9bf",
  null
  
)

export default component.exports